import { render, staticRenderFns } from "./applicationFormsEnNew.vue?vue&type=template&id=0154c4b2&scoped=true&"
import script from "./applicationFormsEnNew.vue?vue&type=script&lang=ts&"
export * from "./applicationFormsEnNew.vue?vue&type=script&lang=ts&"
import style0 from "./applicationFormsEnNew.vue?vue&type=style&index=0&id=0154c4b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0154c4b2",
  null
  
)

export default component.exports